import moment from 'moment';
import { HttpClient } from '@/shared/lib/http-client';

export const fetchTasksList = async ({ userId, startDate, endDate, page, perPage }) => {
  const FIRST_PAGE = 1;
  const ITEMS_PER_PAGE = 4;

  const response = await HttpClient.get('/tasks', {
    user_id: userId || null,
    start_date: startDate !== null ? moment(startDate).format('DD-MM-YYYY') : null,
    end_date: endDate !== null ? moment(endDate).format('DD-MM-YYYY') : null,
    page: page || FIRST_PAGE,
    per_page: perPage || ITEMS_PER_PAGE,
  });

  return response.data?.data;
};
